import React, { FC } from 'react';
import { FormattedNumber } from 'react-intl';
import FormattedDateTime from '../format/FormattedDateTime';
import color from '../../config/color';
import { Equity } from '../../../../api/src/interfaces/shared';
import './SearchEquity.css';

interface Props {
  equity: Equity;
  onClick: () => void;
}

const SearchEquity: FC<Props> = ({ equity, onClick }) => (
  <tr className="mouse-pointer" onClick={onClick}>
    <td title={equity.id}>{equity.name}</td>
    <td className="hide-on-500px">
      <FormattedDateTime
        timestamp={equity.time}
        type={equity.type}
        showClockPrefix
      />
    </td>
    <td className={color.getClassName(equity.percent)}>
      {equity.percent ? (
        <FormattedNumber // eslint-disable-next-line
          style="percent"
          minimumFractionDigits={2}
          maximumFractionDigits={2}
          value={equity.percent / 100}
        />
      ) : (
        '-'
      )}
    </td>
    <td>
      {equity.price ? (
        <FormattedNumber
          minimumFractionDigits={2}
          maximumFractionDigits={2}
          value={equity.price}
        />
      ) : (
        '-'
      )}
    </td>
  </tr>
);

export default SearchEquity;
